import { Injectable } from '@angular/core';
import { AccessTokenMissingException } from '../model/access-token-missing.exception';
import { ApiService } from './api.service';
import { AuthenticatedApiService } from './authenticated-api.service';
import { AuthenticationService } from '../services/authentication.service';
import { PaymentMethodBuilder } from '../builders/payment-method-builder';
import { RESTClientConfig } from '../config';
import * as _ from 'lodash-es';
import CryptoES from 'crypto-es';
import * as i0 from "@angular/core";
import * as i1 from "./api.service";
import * as i2 from "./authenticated-api.service";
import * as i3 from "../services/authentication.service";
import * as i4 from "../config";
export class CreditCardsApiService {
    constructor(api, authenticatedApi, auth, restClientConfig) {
        this.api = api;
        this.authenticatedApi = authenticatedApi;
        this.auth = auth;
        this.restClientConfig = restClientConfig;
        this.productionEnvironment = this.restClientConfig.production;
    }
    addCard(card) {
        if (this.productionEnvironment) {
            return this.addProductionApiCard(card);
        }
        else {
            return this.addDevelopmentApiCard(card);
        }
    }
    deleteCard(userId, paymentMethodId) {
        if (this.productionEnvironment) {
            return this.deleteProductionApiCard(userId, paymentMethodId);
        }
        else {
            return this.deleteDevelopmentApiCard(userId, paymentMethodId);
        }
    }
    calculatePciApiSignature(params) {
        let authorization_token = params['authorization_token'];
        let chain = [];
        _.forOwn(params, function (val, key) {
            if (!_.isNil(val) && !_.isEqual(val, ['signature', 'authorization_token'])) {
                chain.push(`${key}=${String(val)}`);
            }
        });
        return CryptoES.MD5(encodeURI(authorization_token + _.join(chain, '&'))).toString();
    }
    addProductionApiCard(card) {
        let accessToken = this.auth.getAccessToken();
        let isPciApiCall = true;
        if (!accessToken) {
            return Promise.reject(new AccessTokenMissingException());
        }
        let query = {
            user_id: card.userId,
            authorization_token: accessToken,
            cardnumber: card.cardNumber,
            expiration_month: card.expirationMonth,
            expiration_year: card.expirationYear,
            cvv: card.cvv,
            type: card.type,
            company_id: card.companyId,
            cost_center: card.costCenterId,
            alias: card.alias,
            signature: ''
        };
        query.signature = this.calculatePciApiSignature(query);
        let validQueryParams = _.filter(query, val => !_.isNil(val));
        let queryString = _.join(_.map(validQueryParams, (val, key) => `${key}=${String(val)}`), '&');
        let options = {};
        options.headers = { 'Authorization': CryptoES.SHA256(accessToken).toString() };
        return this.api.get('/addcard', query, options, isPciApiCall).toPromise().then(response => {
            return PaymentMethodBuilder.buildPaymentMethod(response.paymethod);
        });
    }
    addDevelopmentApiCard(card) {
        let accessToken = this.auth.getAccessToken();
        let isPciApiCall = true;
        let signature;
        if (!accessToken) {
            return Promise.reject(new AccessTokenMissingException());
        }
        let query = {
            user_id: card.userId,
            authorization_token: accessToken,
            cardnumber: card.cardNumber,
            expiration_month: card.expirationMonth,
            expiration_year: card.expirationYear,
            cvv: card.cvv,
            type: card.type,
            company_id: card.companyId,
            cost_center: card.costCenterId,
            alias: card.alias,
            signature: ''
        };
        query.signature = this.calculatePciApiSignature(query);
        return this.api.get('/addcard', query, {}, isPciApiCall)
            .toPromise()
            .then(response => {
            return PaymentMethodBuilder.buildPaymentMethod(response.paymethod);
        });
    }
    deleteProductionApiCard(userId, paymentMethodId) {
        let accessToken = this.auth.getAccessToken();
        let isPciApiCall = true;
        if (!accessToken) {
            return Promise.reject(new AccessTokenMissingException());
        }
        let query = {
            user_id: userId,
            authorization_token: accessToken,
            paymethod_id: paymentMethodId,
            signature: null
        };
        query.signature = this.calculatePciApiSignature(query);
        let validQueryParams = _.filter(query, val => !_.isNil(val));
        let queryString = _.join(_.map(validQueryParams, (val, key) => `${key}=${String(val)}`), '&');
        let options = {};
        options.headers = { 'Authorization': CryptoES.SHA256(accessToken).toString() };
        return this.api.get(`/deletecard`, query, options, isPciApiCall)
            .toPromise().then(response => response);
    }
    deleteDevelopmentApiCard(userId, paymentMethodId) {
        let accessToken = this.auth.getAccessToken();
        let isPciApiCall = true;
        let query = {
            user_id: userId,
            authorization_token: accessToken,
            paymethod_id: paymentMethodId,
            signature: null
        };
        query.signature = this.calculatePciApiSignature(query);
        if (!accessToken) {
            return Promise.reject(new AccessTokenMissingException());
        }
        return this.api.get(`/deletecard`, query, {}, isPciApiCall)
            .toPromise()
            .then(response => response);
    }
}
CreditCardsApiService.ɵfac = function CreditCardsApiService_Factory(t) { return new (t || CreditCardsApiService)(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.AuthenticatedApiService), i0.ɵɵinject(i3.AuthenticationService), i0.ɵɵinject(i4.RESTClientConfig)); };
CreditCardsApiService.ɵprov = i0.ɵɵdefineInjectable({ token: CreditCardsApiService, factory: CreditCardsApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(CreditCardsApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.ApiService }, { type: i2.AuthenticatedApiService }, { type: i3.AuthenticationService }, { type: i4.RESTClientConfig }]; }, null); })();
//# sourceMappingURL=credit-cards-api.service.js.map